import {Grid} from '@material-ui/core';
import {P} from 'components/TypographyShortcuts';
import {FluidVideo} from 'components';
import {PBold} from 'components/TypographyShortcuts';

const IntroVideoWith = ({
    videoLink = 'https://www.youtube.com/embed/L25HYdHTA_g',
    videoTitle = 'How MM-SEAS Makes It Easy to Renew and Upgrade',
}) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <P paragraph={false} align='center'>
                    We created this quick guide to help you get started!
                </P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    {videoTitle}
                </PBold>
            </Grid>
            <Grid item xs={12}>
                <FluidVideo
                    key={2}
                    data={videoLink}
                    title='MM-SEAS Overview Video'
                />
            </Grid>
            <Grid item></Grid>
            <Grid item xs={12}>
                <PBold align='center' key={3}>
                    If you run into any trouble or need help along the way click
                    on the red HELP button in the menu on the left.
                </PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold align='center' key={4}>
                    We will get in touch right away and figure out how to solve
                    your problem!
                </PBold>
            </Grid>
        </Grid>
    );
};

const IntroVideoWithout = () => {
    return (
        <IntroVideoWith
            videoLink='https://www.youtube.com/embed/9GT1aWVkyT8'
            videoTitle='How MM-SEAS Helps You Get Your License'
        />
    );
};

export default IntroVideoWith;
export {IntroVideoWith, IntroVideoWithout};
